import React from "react";
import { Modal, Carousel } from "antd";


const ModalCarousel = ({ open, onClose, images = [] }) => {
    return (
        <Modal
            open={open}
            footer={null}
            onCancel={onClose}
            width={800}
            centered
            bodyStyle={{
                padding: 0,
                background: "#111827",
                borderRadius: 16,
                minHeight: 500,
                display: "block",
            }}
        >
            <Carousel dotPosition="bottom" style={{ width: "100%", height: 500, background: "#111827", borderRadius: 16 }}>
                {images.map((img, idx) => (
                    <div
                        key={idx}
                        style={{
                            width: "100%",
                            height: 500,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#111827",
                            borderRadius: 16,
                        }}
                    >
                        <img
                            src={img}
                            alt={`Listing image ${idx + 1}`}
                            style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                borderRadius: 16,
                                boxShadow: "0 4px 24px rgba(0,0,0,.18)",
                                background: "#111827",
                            }}
                        />
                    </div>
                ))}
            </Carousel>
        </Modal>
    );
};


export default ModalCarousel;